// import EntypoIcon from 'react-native-vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUIStoreWebsiteSettingPaymentView from 'xui/modules/storeWebsite/BaseUIStoreWebsiteSettingPaymentView'

export default class StoreWebsiteSettingPaymentView extends BaseUIStoreWebsiteSettingPaymentView {}
